export default {
    PRIMARY: '#F7CF47',
    LIGHT: '#FFE077',
    DARK: '#D0AE38',
    GREEN: '#2EC158',
  }